<app-breadcrumb [title]="'Conductores'" [items]="['Vehiculos']" [active_item]="'Conductores'"></app-breadcrumb>
<div class="container-fluid">
  <div class="card">
  <div class="card-header bg-primary">
    <h5 class="text-uppercase text-white">
      <strong>Listado de Conductores Asignados</strong>
    </h5>
  </div>

  <div class="card-body custom-datatable noscroll">
      <div class="row mb-12 ">
      <div class="col-sm-12 col-md-3  ms-auto">
        <div class="input-group">
          <input type="text" class="form-control" placeholder="Buscar....." [(ngModel)]="searchText"
            (input)="filterData()" />
          <span class="input-group-text">
            <i class="fa fa-search"></i> <!-- Icono de búsqueda -->
          </span>
        </div>
      </div>
    </div>
    <div class="custom-datatable table-responsive mt-4">
        <table class="table table-hover table-bordered" id="tblConductor">
          <thead class="bg-primary">
            <tr>
              <th class="text-center" style="cursor: pointer" (click)="sortData('vehiculo_id')">
                <strong>PLACA</strong>
                <i class="fa" [ngClass]="{
                  'fa-sort-up': sortColumn === 'vehiculo_id' && sortDirection === 'asc',
                  'fa-sort-down': sortColumn === 'vehiculo_id' && sortDirection === 'desc',
                  'fa-sort': sortColumn !== 'vehiculo_id'
                }"></i>
              </th>
              
              <th class="text-center" style="cursor: pointer" (click)="sortData('conductor_id')">
                <strong>CÉDULA</strong>
                <i class="fa" [ngClass]="{
                  'fa-sort-up': sortColumn === 'conductor_id' && sortDirection === 'asc',
                  'fa-sort-down': sortColumn === 'conductor_id' && sortDirection === 'desc',
                  'fa-sort': sortColumn !== 'conductor_id'
                }"></i>
              </th>
              
              <th class="text-center" style="cursor: pointer" (click)="sortData('nombre')">
                <strong>NOMBRE</strong>
                <i class="fa" [ngClass]="{
                  'fa-sort-up': sortColumn === 'nombre' && sortDirection === 'asc',
                  'fa-sort-down': sortColumn === 'nombre' && sortDirection === 'desc',
                  'fa-sort': sortColumn !== 'nombre'
                }"></i>
              </th>

            </tr>
          </thead>

          <tbody>
           <tr *ngFor="let conductor of filteredTableItems | paginate: { itemsPerPage: pageSize1, currentPage: page1 }">

              <td class="text-center">{{ conductor.vehiculo_id }}</td>
              <td class="text-center">{{ conductor.conductor_id }}</td>
              <td class="text-uppercase text-center">                      
                {{ conductor.propietario?.primernombre }}
                {{ conductor.propietario?.segundonombre }}
                {{ conductor.propietario?.papellidos }}
                {{ conductor.propietario?.seapellidos }}</td>
            </tr>
          </tbody>
        </table>
    </div>
   <div class="row align-items-center mt-4 g-2">
    <!-- Selector de registros por página -->
    <div class="col-12 col-md-4 d-flex align-items-center justify-content-center justify-content-md-start">
      <label for="pageSize1" class="me-2 mb-0">Mostrar:</label>
      <select id="pageSize1" class="form-select w-auto" [(ngModel)]="pageSize1" (change)="page1 = 1">
        <option *ngFor="let size1 of [5, 10, 20, 50, 100]" [value]="size1">{{ size1 }}</option>
      </select>
      <span class="ms-2">registros por página</span>
    </div>

    <!-- Total de registros -->
    <div class="col-12 col-md-4 text-center my-2 my-md-0">
      <span class="badge bg-primary ms-1"><b><span>Total Registros: </span>{{ conductores.length || 0 }}</b></span>
    </div>

    <!-- Paginador -->
    <div class="col-12 col-md-4 text-center text-md-end">
      <pagination-controls 
        (pageChange)="page1 = $event" 
        [maxSize]="5"
        [directionLinks]="true"
        [autoHide]="true"
        previousLabel="Anterior" 
        nextLabel="Siguiente">
      </pagination-controls>
    </div>

    </div>
    <div class="card-body">
      <div class="btn-showcase text-center">
        <button class="btn btn-outline-success-2x" type="button" placement="top" ngbTooltip="Exportar a Excel"
          (click)="
            exportarExcel(
              'tblConductor',
              'Listado_Conductor_Vehiculo'
            )
          ">
          <i class="icofont icofont-file-excel"></i> EXCEL
        </button>

        <button class="btn btn-outline-danger-2x" type="button" placement="top" ngbTooltip="Exportar a PDF"
          (click)="
            exportToPDF(
              'tblConductor',
              'Listado_Conductor_Vehiculo',
              'Listado de Conductor Vehiculo'
            )
          ">
          <i class="icofont icofont-file-pdf"></i> PDF
        </button>
      </div>
    </div>
  </div>
</div>
</div>
